import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActivityCalendarComponent } from './activity-calendar.component';

import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { LoadingModule } from '@web-frontend/shared/components/loading';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ActivityCalendarComponent],
  imports: [
    CommonModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    MatChipsModule,
    MatIconModule,
    TranslateModule.forChild(),
    LoadingModule,
  ],
  exports: [ActivityCalendarComponent],
})
export class ActivityCalendarModule {}
